import { StylesConfig, Props, CSSObjectWithLabel } from "react-select";
import Utility from "@utility@::@index";

const portal = document.getElementById("portal");

export const SelectMenuStyle = (data?: { menu?: any; option?: any; control?: any; singleValue?: any; multiValue?: any; multiValueLabel?: any; multiValueRemove?: any; input?: any; dark?: boolean; error?: boolean }): StylesConfig => {
    const selectData: StylesConfig = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "transparent",
            border: `2px solid ${data?.dark ? "white" : data?.dark ? "white" : "var(--textColor01)"}`,
            borderRadius: "7px",
            borderColor: data?.error ? "#f04747 !important" : state.isFocused ? "#8c82ce !important" : `${data?.dark ? "white" : data?.dark ? "white" : "var(--textColor01)"} !important`,
            boxShadow: "none",
            opacity: state.isFocused ? "1 !important" : "0.6 !important",
            transition: "0.2s",
            cursor: "pointer",
            overflow: "visible",
            minHeight: "48px",
            ":hover": {
                borderColor: data?.error ? "#f04747 !important" : state.isFocused ? "#8c82ce !important" : `${data?.dark ? "white" : data?.dark ? "white" : "var(--textColor01)"} !important`,
                opacity: state.isFocused ? "1 !important" : "0.8 !important",
            },
            ...data?.control,
        }),
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: data?.dark ? "#171c26" : "var(--backgroundColor02)",
            borderRadius: "7px",
            boxShadow: "box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px",
            zIndex: 5,
            ...data?.menu,
        }),
        menuList: (provided, state) =>
            ({
                ...provided,
                backgroundColor: data?.dark ? "#171c26" : "var(--backgroundColor02)",
                border: `2px solid ${data?.dark ? "#364157" : "var(--backgroundColor05)"}`,
                borderRadius: "7px",
                transition: "0.2s",
                padding: "5px",
                display: "grid",
                gap: "5px",
                zIndex: 5,
            }) as CSSObjectWithLabel,
        group: (provided, state) => ({ display: "grid !important", gap: "5px !important" }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#8c82ce" : state.isFocused ? (data?.dark ? "#1d232f" : "var(--backgroundColor01)") : data?.dark ? "#171c26" : "var(--backgroundColor02)",
            color: data?.dark ? "white" : data?.dark ? "white" : "var(--textColor01)",
            fontSize: "1rem",
            transition: "0.3s",
            borderRadius: "7px",
            overflow: "hidden",
            cursor: "pointer",
            ":active": {
                backgroundColor: "#8c82ce",
            },
            ...data?.option,
        }),
        multiValue: (provided, state) => ({
            ...provided,
            backgroundColor: data?.dark ? "#364157" : "var(--backgroundColor05)",
            transition: "0.3s",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center !important",
            gap: "4px",
            maxHeight: "26px",
            ...data?.multiValue,
        }),
        multiValueLabel: (provided, state) => ({
            ...provided,
            margin: "0",
            padding: "0",
            paddingLeft: "7px",
            paddingRight: (state.data as any).isFixed ? "7px" : "0",
            color: data?.dark ? "white" : "var(--textColor01)",
            fontSize: "0.85rem",
            ...data?.multiValueLabel,
        }),
        multiValueRemove: (provided, state) => ({
            ...provided,
            borderRadius: "0 4px 4px 0",
            color: data?.dark ? "white" : "var(--textColor01)",
            display: (state.data as any).isFixed ? "none" : provided.display,
            height: "26px",
            ...data?.multiValueRemove,
        }),
        valueContainer: (provided, state) =>
            ({
                ...provided,
                padding: state.hasValue && state.isMulti ? "0.42646875rem 13px" : "0 13px",
            }) as CSSObjectWithLabel,
        clearIndicator: (provided, state) =>
            ({
                ...provided,
                transition: "0.2s",
                ":hover": {
                    color: "#f04747",
                },
            }) as CSSObjectWithLabel,
        dropdownIndicator: (provided, state) =>
            ({
                ...provided,
                transition: "0.75s",
                transform: state.isFocused ? "rotate(450deg) !important" : "rotate(0deg) !important",
                ...(state.isFocused ? { color: "#43b581" } : {}),
            }) as CSSObjectWithLabel,
        singleValue: (provided, state) => ({
            ...provided,
            color: data?.dark ? "white" : "var(--textColor01)",
            outline: "none",
            transition: "0.3s",
            margin: 0,
            padding: 0,
            ...data?.singleValue,
        }),
        input: (provided, state) => ({
            ...provided,
            color: data?.dark ? "white" : "var(--textColor01)",
            margin: 0,
            padding: 0,
            overflow: "hidden",
            ...data?.input,
        }),
        menuPortal: (provided, state) =>
            ({
                ...provided,
                zIndex: 206,
            }) as CSSObjectWithLabel,
    };

    return selectData;
};

export const SelectMenuProps: Props = {
    menuPortalTarget: portal,
    menuPlacement: "auto",
    closeMenuOnScroll: true,
    filterOption: (option: any, input) => (input ? (option.data?.search?.toLowerCase().includes(input.toLowerCase() || option.data?.value?.toLowerCase().includes(input.toLowerCase())) ? true : false) : true),
};

export const SelectMenuDefaultFilterProps: Props = {
    menuPortalTarget: portal,
    menuPlacement: "auto",
    closeMenuOnScroll: true,
};

export const IsValidDiscordEmbed = (embed: any): { success: boolean; embed: any } => {
    if (embed?.image?.url && !Utility.IsValidHttpUrl(embed.image.url)) embed.image.url = "";
    if (embed?.thumbnail?.url && !Utility.IsValidHttpUrl(embed.thumbnail.url)) embed.thumbnail.url = "";
    if (embed?.author?.name?.length > 0 || embed?.title?.length > 0 || embed?.description?.length > 0 || embed?.image?.url?.length > 0 || embed?.thumbnail?.url?.length > 0 || embed?.footer?.text?.length > 0 || embed?.fields?.filter((field: any) => field.name?.length > 0 && field.value?.length > 0)?.length > 0) {
        if (embed?.url && !Utility.IsValidHttpUrl(embed.url)) embed.url = "";
        if (embed?.author?.url && !Utility.IsValidHttpUrl(embed.author.url)) embed.author.url = "";
        if (embed?.author?.icon_url && !Utility.IsValidHttpUrl(embed.author.icon_url)) embed.author.icon_url = "";
        if (embed?.footer?.icon_url && !Utility.IsValidHttpUrl(embed.footer.icon_url)) embed.footer.icon_url = "";
        return { success: true, embed };
    }
    return { success: false, embed };
};
export const GetDiscordEmbedSize = (embed: any): number => {
    let size = (embed?.author?.name?.length || 0) + (embed?.title?.length || 0) + (embed?.description?.length || 0) + (embed?.footer?.text?.length || 0);
    embed?.fields?.map((field: any) => (size += field?.name?.length + field?.value?.length));
    return size;
};
export const GetDiscordEmbedImageUrlSize = (embed: any): number => {
    let size = (embed?.thumbnail?.url?.length || 0) + (embed?.image?.url?.length || 0);
    embed?.fields?.map((field: any) => (size += field?.name?.length + field?.value?.length));
    return size;
};
export const GetDiscordEmbedUrlSize = (embed: any): number => {
    let size = (embed?.author?.url?.length || 0) + (embed?.url?.length || 0);
    embed?.fields?.map((field: any) => (size += field?.name?.length + field?.value?.length));
    return size;
};

export const RoleOptionsFilter = (types: ("NO_EVERYONE" | "NO_BOTS" | "NO_ADMIN" | "NO_MANAGER" | "NO_KICK_BAN")[], removeThese?: any[]) => (role: any) => (removeThese && removeThese.length > 0 ? !removeThese.find((b: any) => role.id === b.id) : true) && (types.includes("NO_EVERYONE") ? role.position !== 0 : true) && (types.includes("NO_BOTS") ? !role.managed : true) && (types.includes("NO_ADMIN") ? !Utility.HasDiscordPermission(role.permissions, 0x8) : true) && (types.includes("NO_MANAGER") ? !Utility.HasDiscordPermission(role.permissions, 0x20) : true) && (types.includes("NO_KICK_BAN") ? !Utility.HasDiscordPermission(role.permissions, 0x2) || !Utility.HasDiscordPermission(role.permissions, 0x4) : true);

export const ChannelOptionSvgTypeAdd = (channel: any, noMargin?: boolean) => (
    <div className="flex items-center gap-1">
        <span>
            {channel.type === 0 && (
                <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" role="img">
                    <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M5.88657 21C5.57547 21 5.3399 20.7189 5.39427 20.4126L6.00001 17H2.59511C2.28449 17 2.04905 16.7198 2.10259 16.4138L2.27759 15.4138C2.31946 15.1746 2.52722 15 2.77011 15H6.35001L7.41001 9H4.00511C3.69449 9 3.45905 8.71977 3.51259 8.41381L3.68759 7.41381C3.72946 7.17456 3.93722 7 4.18011 7H7.76001L8.39677 3.41262C8.43914 3.17391 8.64664 3 8.88907 3H9.87344C10.1845 3 10.4201 3.28107 10.3657 3.58738L9.76001 7H15.76L16.3968 3.41262C16.4391 3.17391 16.6466 3 16.8891 3H17.8734C18.1845 3 18.4201 3.28107 18.3657 3.58738L17.76 7H21.1649C21.4755 7 21.711 7.28023 21.6574 7.58619L21.4824 8.58619C21.4406 8.82544 21.2328 9 20.9899 9H17.41L16.35 15H19.7549C20.0655 15 20.301 15.2802 20.2474 15.5862L20.0724 16.5862C20.0306 16.8254 19.8228 17 19.5799 17H16L15.3632 20.5874C15.3209 20.8261 15.1134 21 14.8709 21H13.8866C13.5755 21 13.3399 20.7189 13.3943 20.4126L14 17H8.00001L7.36325 20.5874C7.32088 20.8261 7.11337 21 6.87094 21H5.88657ZM9.41045 9L8.35045 15H14.3504L15.4104 9H9.41045Z"></path>
                </svg>
            )}
            {channel.type === 2 && (
                <svg aria-hidden="true" role="img" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M11.383 3.07904C11.009 2.92504 10.579 3.01004 10.293 3.29604L6 8.00204H3C2.45 8.00204 2 8.45304 2 9.00204V15.002C2 15.552 2.45 16.002 3 16.002H6L10.293 20.71C10.579 20.996 11.009 21.082 11.383 20.927C11.757 20.772 12 20.407 12 20.002V4.00204C12 3.59904 11.757 3.23204 11.383 3.07904ZM14 5.00195V7.00195C16.757 7.00195 19 9.24595 19 12.002C19 14.759 16.757 17.002 14 17.002V19.002C17.86 19.002 21 15.863 21 12.002C21 8.14295 17.86 5.00195 14 5.00195ZM14 9.00195C15.654 9.00195 17 10.349 17 12.002C17 13.657 15.654 15.002 14 15.002V13.002C14.551 13.002 15 12.553 15 12.002C15 11.451 14.551 11.002 14 11.002V9.00195Z" aria-hidden="true"></path>
                </svg>
            )}
            {channel.type === 5 && (
                <svg aria-hidden="true" role="img" width="18" height="18" viewBox="0 0 24 24">
                    <path d="M3.9 8.26H2V15.2941H3.9V8.26Z" fill="currentColor"></path>
                    <path d="M19.1 4V5.12659L4.85 8.26447V18.1176C4.85 18.5496 5.1464 18.9252 5.5701 19.0315L9.3701 19.9727C9.4461 19.9906 9.524 20 9.6 20C9.89545 20 10.1776 19.8635 10.36 19.6235L12.7065 16.5242L19.1 17.9304V19.0588H21V4H19.1ZM9.2181 17.9944L6.75 17.3826V15.2113L10.6706 16.0753L9.2181 17.9944Z" fill="currentColor"></path>
                </svg>
            )}
        </span>
        <span className={`text ${noMargin ? "" : "mb-[2px]"}`} children={channel.name} />
    </div>
);
